import { useApolloClient, useSubscription } from '@apollo/client/react'
import { toast } from 'react-toastify'
import {
  GetUserNotificationsDocument,
  UserNotificationCreatedSubscriptionDocument,
} from 'src/apollo/generated/graphql'
import {
  buildNotificationTitle,
  getNotificationSubjectName,
} from 'src/helpers/notification-message'

export const useSubscriptionUserNotificationCreated = () => {
  const client = useApolloClient()

  useSubscription(UserNotificationCreatedSubscriptionDocument, {
    onData: ({ data: { data } }) => {
      const notification = data?.userNotificationCreated

      if (!notification) return

      const title = buildNotificationTitle(
        notification.type,
        getNotificationSubjectName(notification.data),
      )

      toast.info(title, { position: 'top-right' })

      client.refetchQueries({ include: [GetUserNotificationsDocument] })
    },
  })

  return {}
}
